module.exports = __webpack_public_path__ + "static/media/logo.55d3c580.svg";